import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ThemeQuery from './__generated__/ThemeQuery.graphql.ts';
export function preloadPageLayout(): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query({
		query: ThemeQuery,
	});
}
